import { combineReducers } from "@reduxjs/toolkit";
import newHire from "./newHire"

const rootReducer = combineReducers({
    newHire,
})

export default rootReducer